import request from '@/utils/request'

/**
 * 添加点位
 * @param {*} data
 * @returns
 */
export function fetchAdd(data) {
  return request({
    url: '/jiqiren/station_point_c',
    method: 'POST',
    data,
  })
}
/**
 * 修改点位
 * @param {*} data
 * @returns
 */
export function fetchUpdate(data) {
  return request({
    url: '/jiqiren/station_point_u',
    method: 'PUT',
    data,
  })
}
/**
 * 删除点位
 * @param {*} data
 * @returns
 */
export function fetchDelete(data) {
  return request({
    url: '/jiqiren/station_point_delete',
    method: 'DELETE',
    data,
  })
}
/**
 * 修改点位分组
 * @param {*} data { point_group: "",//分组
 *      station_point_id_array: []点位id数组}
 * @returns
 */
export function fetchUpdateGroup(data) {
  return request({
    url: '/jiqiren/station_point_set_group_u',
    method: 'PUT',
    data,
  })
}
/**
 * 查询点位列表
 * @param {*} params {  "station_point_id":"点位置id", 
    "point_type":"病床/药房/手术室等不同的点位类型",  
    "point_name":"点位名称", 
    "point_zuobiao":"点位在地图上的坐标",  
    "station":"所属区域，和机器所属区域格式一致", 
    "other_info":"其他信息，jsonb"}
 * @returns
 */
export function fetchPoiList(params) {
  return request({
    url: '/jiqiren/station_point_get',
    method: 'GET',
    params,
  })
}
